module.exports = __webpack_public_path__ + "media/images/talent/flow-03-238aec0e0beaed436fb2ad61eeb6b94f.png";